import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { QuizPerformanceFragmentDoc } from '../../fragments/generated/QuizPerformance';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type QuizPerformancesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.PerformancesFilters>;
}>;


export type QuizPerformancesQuery = { contentPerformances: { edges?: Array<{ node: { id: string, entityId: string, isSubmitted: boolean, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, startedOn?: string | null, timeSpent: number, result?: Types.QuizResultEnum | null, maxScore?: number | null, attemptId: string, updatedAt: string, userContentFeedback?: { id: string } | null, maxSubmissionDetails?: { score?: number | null, timeSpent: number, maxScore?: number | null } | null, attempts?: Array<{ attemptId: string, score?: number | null, correctAnswersCount?: number | null, status: Types.PerformanceStatusEnum, maxScore?: number | null, timeSpent: number, isSubmitted: boolean, updatedAt?: string | null, result?: Types.QuizResultEnum | null, scorePercentage?: number | null }> | null, user?: { id: string, name?: string | null } | null } | {} }> | null } };


export const QuizPerformancesDocument = /*#__PURE__*/ gql`
    query quizPerformances($filters: PerformancesFilters) {
  contentPerformances(filters: $filters) {
    edges {
      node {
        ... on QuizPerformanceType {
          ...QuizPerformance
          userContentFeedback {
            id
          }
        }
      }
    }
  }
}
    ${QuizPerformanceFragmentDoc}`;

export function useQuizPerformancesQuery(options?: Omit<Urql.UseQueryArgs<QuizPerformancesQueryVariables>, 'query'>) {
  return Urql.useQuery<QuizPerformancesQuery, QuizPerformancesQueryVariables>({ query: QuizPerformancesDocument, ...options });
};